
<template>
  <v-dialog v-model="dialog" scrollable :persistent="loading"  max-width="800px" transition="dialog-transition" >
    <template v-slot:activator="{ on }" >
      <v-btn color="secondary" icon v-on="on"> <v-icon>mdi-cog</v-icon> </v-btn>
    </template>
    <div v-if="dialog">
      <dialog-loading v-if="loading && dialog && !one_company"></dialog-loading>
      <company-settings v-if="dialog && one_company" 
        :one_company="one_company" 
        @doneUpdate="handleDoneUpdate" 
        @close="handleClose"
      ></company-settings>

    </div>
    
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'DialogCompanySettings',
  //mixins: [ validations ],
  components: {
    CompanySettings: () => import('./CompanySettings.vue'),
  },
  props: {
    company_id: {
      type: [Number, String],
    },
  },
  data() {
    return {
      dialog: false,
      one_company: null,

      loading: false,
    }
  },
  methods: {
    showCompany(id){
      this.loading = true
      Api.Company.show(this.company_id).then(r=>r.data).then(solution=>{
        this.one_company = solution.data.attributes
      }).catch(err=>{
        // auto-comment// console.log({err});
      }).finally(()=>{
        this.loading = false
      })
    },
    cleanUp(){
      this.one_company = null
      this.loading = false
    },
    handleClose(){
      this.dialog = false
      this.one_company = null
    },
    handleDoneUpdate(){
      this.handleClose()
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
        this.showCompany()
      } else if (nv == false){
        this.cleanUp()
      }
    }
  },
}
</script>

<style scoped>

</style>